<template>
  <BaseModal
    :modal-title="$t('organization.deleteCollaboratorInvitation')"
    :value="true"
    @close="$emit('close')"
  >
    <template v-if="collaboratorInvitation" #modal>
      <div class="modal_content text-center">
        <div
          class="mt-2 alert_danger text-normal"
          v-text="
            $t('organization.removeCollaboratorInvitation.message', {
              email: collaboratorInvitation.email,
            })
          "
        />
      </div>
    </template>

    <template #actions>
      <BaseButton
        text
        class="mx-2 ml-auto"
        type="secondary"
        color="#707080"
        @click="$emit('close')"
      >
        {{ $t("utils.cancel") }}
      </BaseButton>
      <BaseButton color="secondary" type="primary" @click="submit">
        {{ $t("utils.delete") }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { deleteOrganizationInvitations } from "../../Services/organizationDashboard.service";
export default {
  name: "OrganizationRemoveCollaboratorDialog",
  props: {
    dialogState: {
      type: Boolean,
    },
    collaboratorInvitation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isSubmiting: false,
    };
  },

  methods: {
    async submit() {
      this.isSubmiting = true;
      try {
        await deleteOrganizationInvitations(
          this.$route.params.organizationId,
          this.collaboratorInvitation.id
        );
        this.$emit("invitation-deleted", this.collaboratorInvitation.id);
        this.$store.dispatch("snackbar/active", {
          message: this.$t(
            "organization.removeCollaboratorInvitation.removeSuccess"
          ),
          type: "SUCCESS",
        });
      } catch (error) {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.isSubmiting = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal_content {
  & > * {
    padding-bottom: 16px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .alert_danger {
    padding: 0 8px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #ff5267;
  }
  .text-normal {
    color: #353542;
  }
}
</style>
